<template>
    <div class="content">
        <img :src="path" />
    </div>
</template>

<script>
export default {
    data(){
        return{
            path:"dp/home-slide/img_05.jpg"
        }
    },
    created(){
       this.path = this.$route.query.path;
       console.log( this.path)
    }
}
</script>


<style lang="scss" scoped>
    .content{
        width: 100%;
        height: 100vh;
        background-color: black;
        text-align: center;
        img{
            height: 100%;
        }
    }
</style>